<template>
  <div style="width: 100vw; height: 100vh;">
    <v-toolbar flat color="white">
      <v-toolbar-title>Standorte</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-alert
      style="margin-bottom: 20px;"
      :value="true"
      icon="info"
      color="info"
      outline
    >
      Es werden die zuletzt gültigen Standortdaten jeder Tour des heutigen Tages angezeigt.
    </v-alert>
    <v-layout>
      <v-flex xs8>
        <gmap-map
      style="width:100%; height: 70vh;"
      :center="center"
      :zoom="zoom"
      :options="{
   zoomControl: true,
   mapTypeControl: true,
   scaleControl: true,
   streetViewControl: true,
   rotateControl: false,
   fullscreenControl: true,
   disableDefaultUi: false
 }">
      <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
        {{infoContent}}
      </gmap-info-window>
      <gmap-marker
        v-for="(m, i) in markers"
        :key="i"
        :position="m.position"
        :clickable="true"
        :draggable="false"
        :icon="driverMarkerOptions"
        @click="mapClick(m, i)"
        @mouseover="mapMouseOver(m, i)"
        @mouseout="mapMouseOut(m, i)"
      ></gmap-marker>
    </gmap-map>
      </v-flex>
      <v-flex xs4>
        <tourlist v-on:openSpecificTour="openSpecificTour($event)"></tourlist>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" max-width="300px">
      <v-card>
        <v-list two-line>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title> {{ dialogdetails.firstname + ' ' + dialogdetails.lastname }} </v-list-tile-title>
              <v-list-tile-sub-title>Fahrer</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title> {{ dialogdetails.kfz }} </v-list-tile-title>
              <v-list-tile-sub-title>Fahrzeug</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title> {{ dialogdetails.loadno }} </v-list-tile-title>
              <v-list-tile-sub-title>Ladeschein</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title> {{ dialogdetails.tourid }} </v-list-tile-title>
              <v-list-tile-sub-title>Tour ID</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-btn color="primary" flat @click="dialog=false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  <v-dialog v-model="showDetail" transition="dialog-bottom-transition" max-width="70vw">
      <TourDetail :key="tourDetailKey" v-model="showDetail" style="height: 90vh;"></TourDetail>
    </v-dialog>
  </div>
</template>

<script>
import Tourlist from '../components/Tourlist.vue';
import TourDetail from '../views/TourDetail.vue';
export default {
  name: 'locations',
  components: {
    Tourlist,
    TourDetail
  },
  data() {
    return {
      totalItems: 0,
      zoom: 10,
      tourDetailKey: 0,
      dialog: false,
      driverMarkerOptions: {
        url: 'http://maps.google.com/mapfiles/ms/micons/truck.png',
        size: { width: 40, height: 40, f: 'px', b: 'px' },
        scaledSize: { width: 40, height: 40, f: 'px', b: 'px' }
      },
      dialogdetails: {},
      statusText: '',
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: true,
      currentMidx: null,
      selectedTour: null,
      showDetail: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      center: { lat: 50.1109221, lng: 8.6821267 },
      markers: [],
      apiData: [{}],
      places: [],
      currentPlace: null
    };
  },
  watch: {
    todaysLast(newValue, oldValue) {
      this.apiData = newValue.items;
      this.totalItems = newValue.items.total;
      console.log(newValue.items);
      for (let each of newValue.items.items) {
        let position = { lat: each.latitude, lng: each.longitude };
        this.markers.push({ position: position, infoText: 'TEST' });
      }
      this.center = {
        lat: newValue.items.items[0].latitude,
        lng: newValue.items.items[0].longitude
      };
    }
  },
  mounted() {
    this.getDataFromApi();
  },
  computed: {
    tours() {
      return this.$store.state.tours.today;
    },
    locations() {
      return this.$store.state.locations.all;
    },
    isLoading() {
      return this.$store.state.locations.loading;
    },
    todaysLast() {
      return this.$store.state.locations.todaysLast;
    },
    locationDetails() {
      return this.$store.state.tour.singleDetail;
    }
  },
  methods: {
    openSpecificTour(loadno) {
      this.$store.dispatch('locations/getLoadnoSpecific', { loadno });
      this.$store.dispatch('tours/getCompleteTour', { loadno });
      this.tourDetailKey += 1;
      this.showDetail = true;
    },
    getDataFromApi() {
      this.$store.dispatch('locations/getTodaysLast', {});
      this.$store.dispatch('tours/getToday', {});
    },
    mapMouseOver(m, idx) {
      console.log('mouseover');
      console.log(m);
      const kfz = this.apiData.items[idx].firstname + ' ' + this.apiData.items[idx].lastname;
      this.infoWindowPos = m.position;
      this.infoContent = kfz;
      this.infoWinOpen = true;
      this.currentMidx = idx;
    },
    mapMouseOut(m, idx) {
      console.log('mouseout');
      console.log(m);
      this.infoWinOpen = false;
      this.currentMidx = null;
    },
    mapClick(m, idx) {
      this.dialogdetails = this.apiData.items[idx];
      this.dialog = true;
      console.log(this.dialogdetails);
    }
  }
};
</script>
